<div fxLayout="row" fxLayoutAlign="space-around center" class="wrapper">
    <mat-spinner [diameter]="iconSizeEnum[size]"></mat-spinner>
    <div class="loading-animation-message" *ngIf="message && canDisplayMessage">
        {{ message }}<cl-animated-ellipsis></cl-animated-ellipsis>
    </div>
</div>
